import React from 'react';
import './SupportPage.css';

const HelpCenter = () => {
  return (
    <div className="support-page">
      <div className="support-header">
        <h1 className="support-title">Help Center</h1>
        <p className="support-subtitle">
          Find answers to frequently asked questions and get help with using V Football.
        </p>
      </div>
      
      <div className="help-grid">
        <div className="help-card">
          <div className="help-card-icon">
            <svg viewBox="0 0 24 24" width="24" height="24">
              <circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" strokeWidth="2"/>
              <path d="M8 14s1.5 2 4 2 4-2 4-2" fill="none" stroke="currentColor" strokeWidth="2"/>
              <line x1="9" y1="9" x2="9.01" y2="9" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
              <line x1="15" y1="9" x2="15.01" y2="9" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </div>
          <h3 className="help-card-title">Getting Started</h3>
          <p className="help-card-text">Learn the basics of using V Football to follow your favorite teams and leagues.</p>
        </div>
        
        <div className="help-card">
          <div className="help-card-icon">
            <svg viewBox="0 0 24 24" width="24" height="24">
              <rect x="3" y="3" width="18" height="18" rx="2" fill="none" stroke="currentColor" strokeWidth="2"/>
              <circle cx="9" cy="9" r="2" fill="none" stroke="currentColor" strokeWidth="2"/>
              <path d="M21 15l-3.086-3.086a2 2 0 0 0-2.828 0L6 21" fill="none" stroke="currentColor" strokeWidth="2"/>
            </svg>
          </div>
          <h3 className="help-card-title">Account & Settings</h3>
          <p className="help-card-text">Manage your account preferences, notifications, and personalization options.</p>
        </div>
        
        <div className="help-card">
          <div className="help-card-icon">
            <svg viewBox="0 0 24 24" width="24" height="24">
              <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" fill="none" stroke="currentColor" strokeWidth="2"/>
              <polyline points="3.27,6.96 12,12.01 20.73,6.96" fill="none" stroke="currentColor" strokeWidth="2"/>
              <line x1="12" y1="22.08" x2="12" y2="12" stroke="currentColor" strokeWidth="2"/>
            </svg>
          </div>
          <h3 className="help-card-title">Live Scores</h3>
          <p className="help-card-text">Understanding live score updates, match timings, and real-time notifications.</p>
        </div>
        
        <div className="help-card">
          <div className="help-card-icon">
            <svg viewBox="0 0 24 24" width="24" height="24">
              <path d="M14 9V5a3 3 0 0 0-6 0v4" fill="none" stroke="currentColor" strokeWidth="2"/>
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2" fill="none" stroke="currentColor" strokeWidth="2"/>
              <circle cx="12" cy="16" r="1" fill="currentColor"/>
            </svg>
          </div>
          <h3 className="help-card-title">Privacy & Security</h3>
          <p className="help-card-text">Learn about data protection, privacy settings, and keeping your account secure.</p>
        </div>
        
        <div className="help-card">
          <div className="help-card-icon">
            <svg viewBox="0 0 24 24" width="24" height="24">
              <path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z" fill="none" stroke="currentColor" strokeWidth="2"/>
              <path d="M8 12l2 2 4-4" fill="none" stroke="currentColor" strokeWidth="2"/>
            </svg>
          </div>
          <h3 className="help-card-title">Troubleshooting</h3>
          <p className="help-card-text">Solutions to common technical issues and platform problems.</p>
        </div>
        
        <div className="help-card">
          <div className="help-card-icon">
            <svg viewBox="0 0 24 24" width="24" height="24">
              <path d="M21 2l-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.778 7.778 5.5 5.5 0 0 1 7.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4" fill="none" stroke="currentColor" strokeWidth="2"/>
            </svg>
          </div>
          <h3 className="help-card-title">API & Developers</h3>
          <p className="help-card-text">Information for developers interested in integrating with our platform.</p>
        </div>
      </div>
      
      <div className="support-content">
        <h2>Frequently Asked Questions</h2>
        
        <h3>General Questions</h3>
        <p><strong>Q: Is V Football free to use?</strong></p>
        <p>A: Yes, V Football is completely free to use. We provide live scores, news, and match updates at no cost to our users.</p>
        
        <p><strong>Q: Do I need to create an account?</strong></p>
        <p>A: An account is not required to view live scores and basic information. However, creating an account allows you to personalize your experience, save favorite teams, and receive notifications.</p>
        
        <p><strong>Q: Which leagues and competitions do you cover?</strong></p>
        <p>A: We cover over 25 European leagues including Premier League, La Liga, Bundesliga, Serie A, Ligue 1, and many more. We also cover major international tournaments and cup competitions.</p>
        
        <h3>Technical Questions</h3>
        <p><strong>Q: Why are live scores not updating?</strong></p>
        <p>A: Live scores typically update every 30-60 seconds. If you're not seeing updates, try refreshing your browser. If the issue persists, please contact our support team.</p>
        
        <p><strong>Q: Can I use V Football on mobile devices?</strong></p>
        <p>A: Yes, V Football is fully optimized for mobile devices and tablets. You can access all features through your mobile browser.</p>
        
        <p><strong>Q: How accurate are the match times and schedules?</strong></p>
        <p>A: We source our data from official feeds and update match information in real-time. However, schedules may change due to weather, safety concerns, or other factors beyond our control.</p>
        
        <h3>Account & Settings</h3>
        <p><strong>Q: How do I change my notification preferences?</strong></p>
        <p>A: Log into your account and visit the Settings page where you can customize which notifications you receive and how often.</p>
        
        <p><strong>Q: Can I delete my account?</strong></p>
        <p>A: Yes, you can delete your account at any time. Contact our support team or use the account deletion feature in your settings.</p>
        
        <p><strong>Q: I forgot my password. How can I reset it?</strong></p>
        <p>A: Use the "Forgot Password" link on the login page to receive a password reset email.</p>
        
        <h3>Data & Privacy</h3>
        <p><strong>Q: How do you protect my personal information?</strong></p>
        <p>A: We take privacy seriously and use industry-standard security measures to protect your data. For detailed information, please read our <a href="/privacy">Privacy Policy</a>.</p>
        
        <p><strong>Q: Do you share my data with third parties?</strong></p>
        <p>A: We do not sell or share your personal information with third parties for marketing purposes. We only share data as described in our Privacy Policy.</p>
        
        <h2>Still Need Help?</h2>
        <p>
          If you can't find the answer to your question in our FAQ, we're here to help! 
          You can reach out to our support team through the following channels:
        </p>
        
        <div className="contact-grid">
          <div className="contact-card">
            <div className="contact-card-icon">
              <svg viewBox="0 0 24 24" width="24" height="24">
                <path d="M3 5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5Z" fill="none" stroke="currentColor" strokeWidth="2"/>
                <path d="m3 7 9 6 9-6" fill="none" stroke="currentColor" strokeWidth="2"/>
              </svg>
            </div>
            <h3 className="contact-card-title">Email Support</h3>
            <p className="contact-card-text">Get help with technical issues or general questions.</p>
            <a href="mailto:support@vfootball.com" className="contact-card-link">support@vfootball.com</a>
          </div>
          
          <div className="contact-card">
            <div className="contact-card-icon">
              <svg viewBox="0 0 24 24" width="24" height="24">
                <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" fill="none" stroke="currentColor" strokeWidth="2"/>
              </svg>
            </div>
            <h3 className="contact-card-title">Contact Form</h3>
            <p className="contact-card-text">Send us a detailed message about your issue or question.</p>
            <a href="/contact" className="contact-card-link">Contact Us</a>
          </div>
        </div>
        
        <div className="info-box">
          <p>
            <strong>Response Time:</strong> We typically respond to support requests within 24 hours during business days. 
            For urgent issues, please include "URGENT" in your subject line.
          </p>
        </div>
      </div>
    </div>
  );
};

export default HelpCenter;